import LogRocket from 'logrocket'
import { LOGROCKET, ROOT_HOSTNAME } from './constants'

// Get visitor ID from URL parameter
function getVisitorIdFromUrl() {
	const urlParams = new URLSearchParams(window.location.search);
	return urlParams.get('vid');
}

// Initialize LogRocket with error handling
try {
	if (LOGROCKET) {
		console.log("🚀 ~ Meeting App LOGROCKET_KEY:", LOGROCKET)
		LogRocket.init(LOGROCKET, {
			rootHostname: ROOT_HOSTNAME,
			network: {
				requestSanitizer: request => {
					// Sanitize sensitive data from requests
					if (request.headers) {
						delete request.headers['Authorization']
						delete request.headers['authorization']
					}
					return request
				},
				responseSanitizer: response => {
					// Sanitize sensitive data from responses
					return response
				}
			},
			dom: {
				inputSanitizer: true, // Automatically sanitize input fields
			}
		})
		
		// Priority 1: Check URL for visitor ID from landing page
		let visitorId = getVisitorIdFromUrl();
		
		// Priority 2: Check localStorage (from main app)
		if (!visitorId) {
			visitorId = localStorage.getItem('geeker_visitor_id');
		}
		
		// Priority 3: Generate new visitor ID
		if (!visitorId) {
			visitorId = 'visitor_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
		}
		
		// Store it in localStorage for cross-app consistency
		localStorage.setItem('geeker_visitor_id', visitorId);
		
		// Identify with LogRocket
		LogRocket.identify(visitorId, {
			source: 'meeting_app_initialization',
			hasUrlParam: !!getVisitorIdFromUrl()
		});
		
		console.log('Meeting App: LogRocket identified with visitor ID:', visitorId);
		
		window.LogRocket = LogRocket; // Make LogRocket globally available
		console.log('Meeting App: LogRocket initialized successfully');
	} else {
		console.warn('Meeting App: LogRocket key not found - skipping initialization');
	}
} catch (error) {
	console.error('Meeting App: Failed to initialize LogRocket:', error);
}

// Helper to identify user in LogRocket
export const identifyUser = (user) => {
	if (user && user.id) {
		LogRocket.identify(user.id, {
			name: `${user.firstName || ''} ${user.lastName || ''}`.trim(),
			email: user.email,
			userType: user.userType,
			// Add custom user data
			customerId: user.customer?.id,
			technicianId: user.technician?.id,
		})
	}
}

// Helper to track custom events
export const trackEvent = (eventName, metadata = {}) => {
	LogRocket.track(eventName, metadata)
}

export default LogRocket
